import type { ReactNode } from 'react'

import Maintenance from '@/pages/Maintenance'

interface MaintenanceGateProps {
  children: ReactNode
}

// Site-wide maintenance gate. Enable by either:
//   - Setting VITE_MAINTENANCE_MODE=true at build time, or
//   - Setting localStorage.setItem('maintenance_mode', 'true') at runtime.
// Add ?bypass_maintenance=1 to the URL to bypass locally.
export function MaintenanceGate({ children }: MaintenanceGateProps) {
  const envFlag = import.meta.env.VITE_MAINTENANCE_MODE === 'true'
  const storageFlag =
    typeof window !== 'undefined' && window.localStorage?.getItem('maintenance_mode') === 'true'
  const bypass =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('bypass_maintenance') === '1'

  if ((envFlag || storageFlag) && !bypass) {
    return <Maintenance />
  }

  return children
}
